import logo from '../Images/brandlogo.png'
import React, { useEffect } from 'react';
import { useState } from 'react';


export default function Header({ toggleSidebar }) {
    const [isScrolled, setIsScrolled] = useState(false);
    // Handle scroll event to toggle background color
    const handleScroll = () => {
        if(window.scrollY > 0){
            setIsScrolled(true);
        }
        else{
            setIsScrolled(false);
        }
    };

     // Add scroll event listener when the component mounts

     useEffect(()=>{
        window.addEventListener('scroll', handleScroll);
        // Clean up the event listener on component unmount
    return () => {
        window.removeEventListener('scroll', handleScroll);
      };
     },[]);

     

  return (
    <header className={isScrolled ? 'scrolled' : ''}>
       
        <nav class="navbar">
      <ul>
        <li><a href="#about">About Us</a></li>
        <li><a href="#services">Facilities</a></li>
        <li><a href="#contact">Contact Us</a></li>
      </ul>
    </nav>
      </header>



      

      
  );
}


